import { useAppSelector } from 'app/hooks';
import { Text } from 'blocks/Text';
import { Localestype } from 'models/types';
import { useDispatch } from 'react-redux';
import { selectLocale, selectedLocale } from 'store/options/optionsSlice';
import { LOCALES } from 'utils/constants';
import * as S from './LanguageSwitcher.styles';

const LanguageSwitcher = ({ color = '' }) => {
  const dispatch = useDispatch();
  const selectedLocaleState = useAppSelector(selectedLocale);
  const locales = LOCALES.filter((e) => e.value !== selectedLocaleState);

  const changeLocale = (value) => {
    dispatch(selectLocale(value));
  };

  return (
    <S.LangChangerWrapper
      justify="flex-end"
      align="center"
      onClick={() => changeLocale(locales[0].value as Localestype)}
    >
      <img src={locales[0].img} title={locales[0].title} alt={locales[0].title} width="20px" />
      <S.LangChanger as={Text} size="small" bold $color={color}>
        {locales[0].title}
      </S.LangChanger>
    </S.LangChangerWrapper>
  );
};

export default LanguageSwitcher;
